import React from 'react'
import PropTypes from 'prop-types'

import styles from './headerBlockLogos.module.scss'
import { clientAirlineLogoPath } from 'app/apiService'

const HeaderBlockLogos = ({ logos = [] }) => {
  return (
    <div className={styles.headerBlockLogos}>
      {logos.map(({ code, name }, index) => (
        <img className={styles.logo} src={clientAirlineLogoPath(code)} key={index} alt={name} />
      ))}
    </div>
  )
}

HeaderBlockLogos.propTypes = {
  logos: PropTypes.array,
}

export { HeaderBlockLogos }
